export default __webpack_public_path__ + "static/media/bg.633d1613.webp";